import gql from 'graphql-tag';

export const GlobalSocialStats = gql`
	query GlobalSocialStats {
		allGlobalSocialStats {
			_id
			lastUpdated
			statistics {
				slug {
					current
				}
				label
				value
				longFormStatistic
			}
		}
	}
`;
